import React from "react";

function ItemCar({ item }) {
  return (
    <div className="swiper-item">
      <a href={"/detail/" + item.id}>
        <div className="swiper-header">
          <span>Động cơ {item.dc}</span>
          <span>Dung tích {item.dt} cc</span>
        </div>
        <div className="swiper-img">
          <img
            src={item.img_url}
            alt="/"
            className="swiper-image-item swiper-image-item-url"
          />
          <img
            src={item.img_hover}
            alt="/"
            className="swiper-image-item swiper-image-item-hover"
          />
        </div>
        <div className="swiper-name">
          <h5>{item.name}</h5>
        </div>
        <div className="swiper-price">
          <span>{item.price}</span>
          <sup className="swiper-vn"> VND</sup>
        </div>
        <div className="swiper-note">
          <span>{item.slot} Chỗ</span>
          <span>{item.type}</span>
        </div>
      </a>
    </div>
  );
}

export default ItemCar;
